function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.191 13.071H20.7v2.566h1.27a5.5 5.5 0 0 0 1.744-.292 4.5 4.5 0 0 0 .848-.383 3.15 3.15 0 0 1-.589-1.623 3.43 3.43 0 0 1 .616-2.416l.264-.305.314.253a4 4 0 0 1 1.575 2.538 3.84 3.84 0 0 1 2.913.271l.345.2-.181.354a3.63 3.63 0 0 1-3.648 1.74c-2.173 5.413-6.9 7.976-12.642 7.976A7.96 7.96 0 0 1 6.3 20.211l-.025-.043-.226-.459a7.3 7.3 0 0 1-.579-3.693l.035-.38h2.143v-2.565h2.51v-2.51h5.02v-2.51h3.012v5.02Z",
  style: {
    fill: "#3a4e55"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.324 14.021a3.31 3.31 0 0 0-1.418-2.821 3.07 3.07 0 0 0 .289 3.821 5.28 5.28 0 0 1-3.225 1.037H5.883a6.8 6.8 0 0 0 .667 3.737l.183.335a6 6 0 0 0 .379.569q.992.064 1.829.045a9 9 0 0 0 2.669-.389.193.193 0 1 1 .126.365q-.135.047-.281.088a8.4 8.4 0 0 1-1.845.3c.044 0-.046.007-.046.007l-.082.007a21.455 21.455 0 0 1-2.008-.006l-.01.007a7.88 7.88 0 0 0 6.063 2.41c5.56 0 10.276-2.465 12.365-8 1.482.152 2.906-.226 3.553-1.49a3.5 3.5 0 0 0-3.122-.022",
  style: {
    fill: "#00aada"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.324 14.021a3.31 3.31 0 0 0-1.418-2.821 3.07 3.07 0 0 0 .289 3.821 5.28 5.28 0 0 1-3.225 1.037H6.836a5.22 5.22 0 0 0 2.106 4.686 9 9 0 0 0 2.669-.389.193.193 0 1 1 .126.365q-.135.047-.281.088a9 9 0 0 1-1.894.314l-.019-.022c1.892.971 4.636.967 7.782-.241a21.87 21.87 0 0 0 9.1-6.889l-.1.048",
  style: {
    fill: "#27b9ec"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.913 17.732a6.4 6.4 0 0 0 .637 2.061l.183.335a6 6 0 0 0 .379.569q.992.064 1.829.045a9 9 0 0 0 2.669-.389.193.193 0 1 1 .126.365q-.135.047-.281.088a8.8 8.8 0 0 1-1.891.307h-.1q-.438.025-.922.026c-.351 0-.709-.007-1.1-.026a7.91 7.91 0 0 0 6.076 2.413c4.76 0 8.9-1.807 11.3-5.8Z",
  style: {
    fill: "#088cb9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.98 17.732a4.83 4.83 0 0 0 1.961 3.01 9 9 0 0 0 2.669-.389.193.193 0 1 1 .126.365q-.135.047-.281.088a9 9 0 0 1-1.9.307c1.892.971 4.628.957 7.773-.252a20.6 20.6 0 0 0 5.377-3.13Z",
  style: {
    fill: "#039cc7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.889 13.671h.172v1.813h-.172zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813H9.23v-1.813Zm-.33 0h.179v1.813H8.9v-1.813Zm-.33 0h.179v1.813H8.57zm-.323 0h.172v1.813h-.17v-1.813Zm-.181-.181h2.175v2.176H8.066V13.49ZM12.4 11.161h.172v1.813H12.4zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.178v1.813h-.178zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176h-2.175v-2.177Z",
  style: {
    fill: "#00acd3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.4 13.671h.172v1.813H12.4zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.178v1.813h-.178zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176h-2.175z",
  style: {
    fill: "#26c2ee"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.909 13.671h.172v1.813h-.172zm-.33 0h.179v1.813h-.178zm-.33 0h.179v1.813h-.178zm-.33 0h.181v1.813h-.179v-1.813Zm-.33 0h.179v1.813h-.179zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176h-2.174V13.49Z",
  style: {
    fill: "#00acd3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.909 11.161h.172v1.813h-.172zm-.33 0h.179v1.813h-.178zm-.33 0h.179v1.813h-.178zm-.33 0h.181v1.813h-.179v-1.813Zm-.33 0h.179v1.813h-.179zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176h-2.174v-2.177ZM17.42 13.671h.172v1.813h-.172zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813H16.1zm-.323 0h.172v1.813h-.172zm-.177-.181h2.176v2.176H15.6z",
  style: {
    fill: "#26c2ee"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.42 11.161h.172v1.813h-.172zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813H16.1zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176H15.6v-2.177Z",
  style: {
    fill: "#00acd3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.42 8.65h.172v1.813h-.172zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813H16.1zm-.323 0h.172v1.813h-.172zm-.177-.181h2.176v2.176H15.6z",
  style: {
    fill: "#26c2ee"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.93 13.671h.17v1.813h-.17zm-.33 0h.178v1.813H19.6zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.33 0h.179v1.813h-.179zm-.323 0h.172v1.813h-.172zm-.181-.181h2.176v2.176h-2.175z",
  style: {
    fill: "#00acd3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.616 19.193a.6.6 0 1 1-.6.6.6.6 0 0 1 .6-.6",
  style: {
    fill: "#d5eef2"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.616 19.363a.4.4 0 0 1 .156.029.175.175 0 1 0 .241.236.43.43 0 1 1-.4-.265M2 17.949h27.92c-.608-.154-1.923-.362-1.707-1.159-1.105 1.279-3.771.9-4.444.267-.749 1.087-5.111.674-5.415-.173-.939 1.1-3.85 1.1-4.789 0-.3.847-4.666 1.26-5.415.173-.673.631-3.338 1.012-4.444-.267.217.8-1.1 1.005-1.707 1.159",
  style: {
    fill: "#3a4e55"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.211 23.518a5.3 5.3 0 0 1-2.756-2.711 9.2 9.2 0 0 1-1.987.3q-.436.024-.917.025-.554 0-1.168-.033a7.94 7.94 0 0 0 6.145 2.43q.344 0 .683-.013",
  style: {
    fill: "#c0dbe1"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.007 21.773a5.2 5.2 0 0 1-.552-.966 9.2 9.2 0 0 1-1.987.3 6.3 6.3 0 0 0 2.539.664",
  style: {
    fill: "#d5eef2"
  }
}));
export default SvgDocker;